module.exports = __webpack_public_path__ + "static/media/house-1.bbd84f72.png";